<template lang="pug">
  div(v-cloak)
    div#loading(v-show="loading" v-bind:style="{minHeight: winHeight + 'px' }")
      span.primary--text LOADING
      img(src='static/images/loading.png')
    div(v-show='!loading')
      CommonHeader
      main
        div.bg_lawn
          div#top(xs12)
            v-flex.top_mask
              div.mask
              span.scroll(v-scroll-to="'#about'")
                a.white--text
                  i.text-xs-center
            v-layout.contents_wrap(row wrap)
              v-flex.contents(offset-md3 md6 offset-xs1 xs10)
                v-img(src="static/images/top_logo.png" alt="ピーチwidthアップルベース新発売！持ってウキウキシャリッと果汁！Juicies" max-width="800px" contain)
              video.hidden-xs-only(v-show="video" autoplay muted)
                source(src='static/images/top_video.mp4', type='video/mp4')
                p 動画を再生するには、videoタグをサポートしたブラウザーが必要です。
          v-layout(row wrap)#about.anchor
            div.side_item
              img.side_l(src="static/images/side_left.png")
              img.side_r(src="static/images/side_right.png")
            v-flex.px-4.my-4(xs8 offset-xs2)
              v-img(src="static/images/nz_flag.png" alt="from NZ" max-width="300px" style="margin:0 auto;" contain)
            v-flex.mb-4(xs12)
              h1.white--text ニュージーランド発!
                br.sm
                | シンプル素材のフルーツアイス
                br.sm
                | ジューシーズ
            v-container
              v-layout.buttons(row wrap)
                v-flex(xs6 sm3 v-scroll-to="item.to" v-for="item in buttons" :key="item.title")
                  a.justify-center.primary--text {{item.title}}
                  img(:src='item.src')
          v-layout(row wrap)#point.text-xs-center.anchor
            v-flex.side.side_l(md1 hidden-sm-and-down)
              img(:src='item.src' v-for="(item, index) in leftPics" :class="['l' + index]" :key="item.index")
            v-flex.px-4(md8 sm12 offset-md1)
              h2.py-2
                v-img(src='static/images/headline_point.png' alt="3つのポイント" style="max-width:750px;margin: 0 auto;" contain)
              v-layout.point_wrap(row wrap v-for="item in points" :key="item.title")
                v-flex(xs12 sm7)
                  v-layout.heading_wrap(row wrap)
                    v-flex(xs12 sm10)
                      v-img.mt-2.heading(:src="item.imageSrc" :alt="item.alt" contain)
                    v-flex(xs0 sm2)
                      v-img.arrow(src="static/images/arrow.png" contain)
                  div
                    h3(style="font-weight:normal").pt-3
                      | {{item.title}}
                    p {{item.text1}}
                      br
                      | {{item.text2}}
                v-flex.mt-1(xs8 offset-xs2 sm5 offset-sm0)
                  v-img.svg(:src='item.svgSrc' contain)
            v-flex.side.side_r(md1 offset-md1 hidden-sm-and-down)
              img(:src='item.src' v-for="(item, index) in rightPics" :class="['r' + index]" :key="item.index")
          v-container#scene.anchor
            h2.pb-4
              v-flex(xs8 offset-xs2)
                v-img(src="static/images/handy.png" alt="持ちやすく汚れにくい！" style="max-width:350px;margin: 0 auto;" contain)
              v-img(src="static/images/headline_scene.png" alt="こんなシーンにおすすめ！" style="max-width:750px;margin: 0 auto;" contain)
            v-layout.mt-5(row wrap v-for="(item, index) in scenes" :key="item.title")
              v-flex.images(xs12 sm6)
                v-img.photo(:src="item.photoSrc" aspect-ratio="1.4")
                v-img.pic(:src="item.picSrc" aspect-ratio="1")
              v-flex(xs12 sm6)
                span.white--text.mt-5.mb-1 {{item.title}}
                h3.white--text.mb-2 {{item.title2}}
                p {{item.text1}}
                  br.sm-up
                  | {{item.text2}}
                  br
                  | {{item.text3}}
                img.item(:src="item.itemSrc" :class="['i' + index]")
        div#lineup.anchor.primary--text
          span.border_branch
          div.series.series_j.text-xs-center
            v-flex.lu_head(xs12)
              v-flex(xs6 offset-xs3)
                img(src="static/images/logo.png" width="250px" style="margin: 0 auto")
              h2 ジューシーズシリーズ
              p.py-1.px-3 後味すっきり！
                br.xs
                | フルーツ本来の甘みが口いっぱいに広がる
                br.xs
                | 爽やかなアイスです。
                br
                | りんごストレート果汁たっぷり、
                br.xs
                | トータル果汁（果肉）99%！
            v-flex.mb-4.lu_head_mask(xs12)
            v-flex.item_wrap(xs12 v-for="item in categoryJuicies" :key="item.key" :class="item.key")
              v-parallax(:src="item.display.image.prlImg.src")
                v-layout(row).item_contents
                    v-flex(xs2 sm3 md3 offset-xs1 offset-sm2 offset-md0)
                      img.new(v-if="item.new" src='static/images/lineup_new.png' alt="NEW！")
                      v-img.item_img.pa-2.mt-2(:src="item.display.image.itemImg.src" :alt="item.display.image.itemImg.alt" max-width="90px" contain)
                    v-flex(xs8 sm5 md5 offset-xs1 offset-sm0).item_text
                      img(:src="item.display.image.commentImg.src" :alt="item.display.image.commentImg.alt" class="item_comment")
                      div(:style="{color: item.display.color}")
                        h3
                          span(style="font-size:1.1rem;") {{item.prefixTitle}}
                          br
                          span.item_title.mt-2 {{item.title}}
                            br
                            span(style="font-size:1.2rem;") {{item.title2}}
                        span(style="font-family: 'Dokdo', cursive;") {{item.english}}
                      div.primary--text.board
                        p りんごストレート果汁
                        i.material-icons(:style="{color: item.display.color}") add_circle
                        p {{item.material}}
                        p {{item.materialType}}
                      span.primary--text(style="font-size:0.6rem;") {{item.materialDetail}}
          span.border_branch_t
          div.series.series_c.text-xs-center
            v-flex.lu_head
              v-flex(xs4 offset-xs4)
                img(src="static/images/logo_coconut.png" width="220px" style="margin: 0 auto")
              h2 ココナッツジューシーズシリーズ
              p.py-1.px-3 果汁感はそのままに、
                br.xs
                | ココナッツクリームをミックス！
                br
                | ジューシーでなめらか。
                br.xs
                | ココナッツの風味がほのかに香ります。
            v-flex.mb-4.lu_head_mask(xs12)
            v-flex.item_wrap(xs12 v-for="item in categoryCoconuts" :key="item.key" :class="item.key")
              v-parallax(:src="item.display.image.prlImg.src")
                v-layout(row).item_contents
                    v-flex(xs2 sm3 md3 offset-xs1 offset-sm2 offset-md0)
                      img.new(v-if="item.new" src='static/images/lineup_new.png' alt="NEW！")
                      v-img.item_img.pa-2.mt-2(:src="item.display.image.itemImg.src" :alt="item.display.image.itemImg.alt" max-width="90px" contain)
                    v-flex(xs8 sm5 md5 offset-xs1 offset-sm0).item_text
                      img(:src="item.display.image.commentImg.src" :alt="item.display.image.commentImg.alt" class="item_comment")
                      div(:style="{color: item.display.color}")
                        h3
                          span(style="font-size:1.1rem;") {{item.prefixTitle}}
                          br
                          span.item_title.mt-2 {{item.title}}
                            br
                            span(style="font-size:1.2rem;") {{item.title2}}
                        span(style="font-family: 'Dokdo', cursive;") {{item.english}}
                      div.primary--text.board
                        p りんごストレート果汁
                        i.material-icons(:style="{color: item.display.color}") add_circle
                        p {{item.material}}
                        p {{item.materialType}}
                      span.primary--text(style="font-size:0.6rem;") {{item.materialDetail}}

        span.border_branch
        div#nz.white--text
          v-container
            v-layout(row wrap)
              v-flex(md12)
                h2.text-xs-center ニュージーランドの
                  br.xs
                  | 太陽の恵みがたっぷり
                p.mt-3.text-xs-left.text-sm-center ニュージーランドの南島北西部、国内でも特に晴天率が高く温暖な気候を保ち、
                 br.sm-up
                 | 国立公園も有するネルソン・タスマン地方で
                 br.sm-up
                 | 収穫されたりんごをふんだんに使用しています。
                div.apple
                  v-img(src="static/images/nz_apple.png" alt="りんご" contain)
                  v-img(src="static/images/nz_apple_pic.png" alt="ネルソン地図" contain)

        span.border_branch
        div.bg_lawn.text-xs-center
          v-container#freezer.anchor
             v-layout(row wrap)
               v-flex(xs6 offset-xs3 sm4 offset-sm4 md5 offset-md0 lg4 offset-lg2 xl3 offset-xl3)
                 v-img(src="static/images/freezer.png" alt="Juicies冷凍庫" contain max-width="400px")
               v-flex(xs12 md7 lg4).pt-2
                 span どこかで見かけるかも？
                 h2.my-3 Juicies冷凍庫
                 p.my-3 屋内、屋外で使えるJuicisの専用冷凍庫！
                  br
                  | 各地の店舗、施設、移動販売等で
                  br
                  | 設置、販売していただいています。
                 router-link(to="/freezer")
                   v-btn(color="secondary" depressed)
                    p.primary--text 施設、店舗の方へ
                      br
                      span.primary--text 専用冷凍庫を無料貸出致します!
                       br
                       |詳しくはこちら！
          v-container#awords
            h2.mb-4 【NZ FOOD AWARDS】受賞
            v-layout(row wrap)
               v-flex.justify-center(xs12 sm4 offset-sm2 lg3 offset-lg3 xl2 offset-xl4)
                 img.ma-2(src="static/images/awards_2014.png" alt="2014受賞マーク")
                 p 【Juicies】
                  br
                  | 2014 NZ Food Awards
                  br
                  | 冷凍食品部門
               v-flex(xs12 sm4 lg3 xl2)
                 img.ma-2(src="static/images/awards_2015.png" alt="2015受賞マーク")
                 p 【Tasman Bay Food Group】
                  br
                  | 2015 Rabobank Business Innovation Award
                  br
                  | NZTE Export Innovation Award
          span.border_flag.mb-3
          v-container#character
            p 楽しいひとときに
              br.xs
              | Juicies!
            v-flex.mt-3(xs8 offset-xs2 sm4 offset-sm4)
              v-img(src="static/images/chara_boya-cnc.png" alt="ジューシーズ坊や・ココナッツちゃんイラスト" max-width="350px" contain)
            span.pr-3 ジューシーズ坊や
            span.pl-3 ココナッツちゃん
        span.border_leaf

        v-container#company.text-xs-center.primary--text
          v-layout(row wrap)
            v-flex(xs12)
              v-flex.my-2.justify-center(xs12 sm4 offset-sm4)
                a(href="http://www.tasmanbay.co.nz/")
                  img(src="static/images/tasmanbay_logo.png" alt="タスマンベイ・フードグループロゴ")
              p.mb-1 [製造元]
              h3 タスマンベイ・フードグループ
              p.my-2.text-xs-left.text-sm-center 製造元タスマンベイ・フードグループは、ニュージーランド、ネルソンに拠点を置く食品製造会社です。
                br
                |1984年設立以来、主力商品Juiciesをはじめ、自然素材、安全にこだわった商品の製造を続けています。
              a.my-3.brown--text.lighten-3(href="http://www.tasmanbay.co.nz/") www.tasmanbay.co.nz
          v-layout(row wrap)#contact
            v-flex(xs12)
              h2.mt-5 お問い合せ
              v-flex.my-2.justify-center(xs12 sm4 offset-sm4)
                a(href="http://www.otani-shokai.com/")
                  img(src="static/images/trading_logo.png" alt="大谷商会ロゴ")
              p.mb-1 [輸入販売元]
              h3 株式会社大谷商会 国際部
              address.my-2 〒950-0814 新潟県新潟市東区逢谷内463
                br
                span TEL 025-275-8185
                span.mr-1 FAX 025-275-8186
              a.primary--text(href="mailto:kokusai@otani-shokai.com").mail E-mail: kokusai@otani-shokai.com
              br
              a.my-3.brown--text.lighten-3(href="http://www.otani-shokai.com/") www.otani-shokai.com

        v-btn.totop.primary--text.hidden-xs-only(
          v-scroll-to="'#top'"
          color="secondary"
          fixed
          fab
          right
          bottom
          outline
          style="z-index:50"
          ) TOP
      CommonFooter
      span.footer_pic

</template>

<script>
import CommonHeader from '@/app/pages/Landing/Header.vue'
import CommonFooter from '@/app/pages/Landing/Footer.vue'
import _ from 'underscore'

export default{
  components: {
    CommonHeader,
    CommonFooter
  },
  mounted: function () {
    this.$vuetify.theme.primary = '#3e2723'
    this.$vuetify.theme.secondary = '#ffcc00'
    // Loading
    setTimeout(() => {
      this.loading = false
    }, 1000)
  },
  data () {
    return {
      // Loading
      loading: true,
      // Window Size
      winWidth: window.innerWidth,
      winHeight: window.innerHeight,
      // video
      video: true,
      buttons: [{
        to: '#point',
        title: '３つのポイント',
        src: require('@/../static/images/icon_boya.png')
      }, {
        to: '#scene',
        title: 'おすすめシーン',
        src: require('@/../static/images/icon_scene.png')
      }, {
        to: '#lineup',
        title: 'ラインナップ',
        src: require('@/../static/images/icon_items.png')
      }, {
        to: '#freezer',
        title: '専用冷凍庫',
        src: require('@/../static/images/icon_freezer.png')
      }],
      leftPics: [ {
        src: require('@/../static/images/fruits_strowberry.png')
      }, {
        src: require('@/../static/images/fruits_lemon.png')
      }, {
        src: require('@/../static/images/fruits_berry1.png')
      }, {
        src: require('@/../static/images/fruits_coconuts.png')
      }, {
        src: require('@/../static/images/fruits_mango.png')
      }],
      rightPics: [{
        src: require('@/../static/images/fruits_apple.png')
      }, {
        src: require('@/../static/images/fruits_berry2.png')
      }, {
        src: require('@/../static/images/fruits_orange.png')
      }, {
        src: require('@/../static/images/fruits_pine.png')
      }],
      points: [{
        imageSrc: require('@/../static/images/point_text1.png'),
        alt: '砂糖・甘味料・着色料不使用',
        svgSrc: require('@/../static/images/point_1.svg'),
        title: '砂糖・甘味料・着色料不使用',
        text1: 'からだにうれしくて安心!',
        text2: 'フルーツ本来の甘さを楽しめます。'
      }, {
        imageSrc: require('@/../static/images/point_text2.png'),
        alt: 'りんごストレート果汁が88%以上',
        svgSrc: require('@/../static/images/point_2.svg'),
        title: 'りんごストレート果汁が88%以上',
        text1: '素材そのままの風味を味わえる!'
      }, {
        imageSrc: require('@/../static/images/point_text3.png'),
        alt: 'カロリー1本55kcal以下!',
        svgSrc: require('@/../static/images/point_3.svg'),
        title: 'カロリーはうれしい1本55kcal以下',
        text1: 'からだのことを気にされる方にも',
        text2: 'おすすめです。'
      }],
      scenes: [{
        photoSrc: require('@/../static/images/scene_photo_outdoor.jpg'),
        picSrc: require('@/../static/images/scene_pic1.png'),
        itemSrc: require('@/../static/images/item_j_apple.png'),
        title: 'Outdoor',
        title2: 'アウトドアで',
        text1: 'キャンプやピクニックで！',
        text2: '持ち歩きしやすく',
        text3: '外でも食べやすい！'
      }, {
        photoSrc: require('@/../static/images/scene_photo_marine.jpg'),
        picSrc: require('@/../static/images/scene_pic2.png'),
        itemSrc: require('@/../static/images/item_c_pineapple.png'),
        title: 'Marine Leisure',
        title2: '海やプールで',
        text1: 'もちろん、',
        text2: '夏の海やプールにもぴったり！',
        text3: 'ベタベタせずすっきり！'
      }, {
        photoSrc: require('@/../static/images/scene_photo_sports.jpg'),
        picSrc: require('@/../static/images/scene_pic3.png'),
        itemSrc: require('@/../static/images/item_j_tropical.png'),
        title: 'Sports',
        title2: 'スポーツの時に',
        text1: '身体を動かす前後に、',
        text2: 'スッキリリフレッシュ！',
        text3: '砂糖甘味料不使用でうれしい！'
      }, {
        photoSrc: require('@/../static/images/scene_photo_drive.jpg'),
        picSrc: require('@/../static/images/scene_pic4.png'),
        itemSrc: require('@/../static/images/item_c_mango.png'),
        title: 'Drive',
        title2: 'ドライブ',
        text1: '汚れにくいから',
        text2: '車の中でもおすすめ！',
        text3: '旅のお供に!'
      }],
      items: [{
        // チェリー
        key: 'j_cherry',
        new: true,
        prefixTitle: 'ジューシーズ',
        title: 'チェリー',
        title2: 'withアップルベース',
        english: 'Cherry',
        energy: 51,
        material: '濃縮',
        materialType: 'さくらんぼ果汁',
        category: 'juicies',
        display: {
          color: '#74001a',
          lightColor: '#f2cdcf',
          descriptions: [
            'ふんわりエレガントな香り',
            '芳醇で甘酸っぱい果汁感'
          ],
          image: {
            itemImg: {
              src: require('@/../static/images/item-l_j_cherry.png'),
              alt: 'アップル商品画像'
            },
            commentImg: {
              src: require('@/../static/images/lineup_cmt_j_cherry.svg'),
              alt: 'りんご好きにはたまらない！'
            },
            prlImg: {
              src: require('@/../static/images/lineup_bg_j_cherry.jpg')
            }
          }
        }
      }, {
        // ピーチ
        key: 'j_peach',
        prefixTitle: 'ジューシーズ',
        title: 'ピーチ',
        title2: 'withアップルベース',
        english: 'Peach',
        energy: 47,
        material: 'ももピューレ',
        materialType: 'りんご濃縮還元果汁',
        category: 'juicies',
        display: {
          color: '#ed7969',
          lightColor: '#ffe5e1',
          descriptions: [
            '桃感じゅわ！',
            'りんごのストレート果汁をベースにピーチピューレをミックスしました'
          ],
          image: {
            itemImg: {
              src: require('@/../static/images/item-l_j_peach.png'),
              alt: 'ピーチ商品画像'
            },
            commentImg: {
              src: require('@/../static/images/lineup_cmt_j_peach.svg'),
              alt: 'もも感じゅわ！ピーチピューレをミックス!'
            },
            prlImg: {
              src: require('@/../static/images/lineup_bg_j_peach.jpg')
            }
          }
        }
      }, {
        // アップル
        key: 'j_apple',
        prefixTitle: 'ジューシーズ',
        title: 'アップル',
        english: 'Apple',
        energy: 48,
        material: 'りんご',
        materialType: '濃縮還元果汁',
        category: 'juicies',
        display: {
          color: '#ea372a',
          lightColor: '#ffc9cb',
          descriptions: [
            'トータル99％のりんご果汁を使った',
            'りんごを存分に楽しんでいただける商品です。'
          ],
          image: {
            itemImg: {
              src: require('@/../static/images/item-l_j_apple.png'),
              alt: 'アップル商品画像'
            },
            commentImg: {
              src: require('@/../static/images/lineup_cmt_j_apple.svg'),
              alt: 'りんご好きにはたまらない！'
            },
            prlImg: {
              src: require('@/../static/images/lineup_bg_j_apple.jpg')
            }
          }
        }
      }, {
        // トロピカル
        key: 'j_tropical',
        prefixTitle: 'ジューシーズ',
        title: 'トロピカル',
        english: 'Tropical',
        energy: 46,
        material: 'トロピカルフルーツ※',
        materialType: '濃縮還元果汁',
        materialDetail: '※りんご、オレンジ、パインアップル、パッションフルーツ、マンゴー',
        category: 'juicies',
        display: {
          color: '#00b2e8',
          lightColor: '#cdf0f9',
          descriptions: [
            'りんごのストレート果汁に、オレンジ、パインアップル、パッションフルーツ、りんご、マンゴーの還元果汁をミックス。',
            'トロピカル風味のフルーツ感あふれるテイストです。'
          ],
          image: {
            itemImg: {
              src: require('@/../static/images/item-l_j_tropical.png'),
              alt: 'トロピカル商品画像'
            },
            commentImg: {
              src: require('@/../static/images/lineup_cmt_j_tropical.svg'),
              alt: '南国フルーツをミックス さわやかトロピカル!'
            },
            prlImg: {
              src: require('@/../static/images/lineup_bg_j_tropical.jpg')
            }
          }
        }
      }, {
        // オレンジ
        key: 'j_orange',
        prefixTitle: 'ジューシーズ',
        title: 'オレンジ',
        title2: 'withアップルベース',
        english: 'Orange with Apple base',
        energy: 46,
        material: 'オレンジ',
        materialType: '濃縮還元果汁',
        category: 'juicies',
        display: {
          color: '#f79d32',
          lightColor: '#fcebaa',
          descriptions: [
            'りんごのストレート果汁に、オレンジの還元果汁をミックス。',
            'りんごとオレンジの甘さと爽やかな風味が広がります。'
          ],
          image: {
            itemImg: {
              src: require('@/../static/images/item-l_j_orange.png'),
              alt: 'オレンジ商品画像'
            },
            commentImg: {
              src: require('@/../static/images/lineup_cmt_j_orange.svg'),
              alt: '甘くてすっきり元気なオレンジ!'
            },
            prlImg: {
              src: require('@/../static/images/lineup_bg_j_orange.jpg')
            }
          }
        }
      }, {
        // レモネード
        key: 'j_lemonade',
        prefixTitle: 'ジューシーズ',
        title: 'レモネード',
        title2: 'withアップルベース',
        english: 'Lemonade with Apple base',
        energy: 47,
        material: 'レモン',
        materialType: '濃縮還元果汁',
        category: 'juicies',
        display: {
          color: '#79b703',
          lightColor: '#d7efb6',
          descriptions: [
            'りんごのストレート果汁に、オレンジの還元果汁をミックス。',
            'りんごとオレンジの甘さと爽やかな風味が広がります。'
          ],
          image: {
            itemImg: {
              src: require('@/../static/images/item-l_j_lemonade.png'),
              alt: 'レモネード商品画像'
            },
            commentImg: {
              src: require('@/../static/images/lineup_cmt_j_lemonade.svg'),
              alt: '暑い日に食べたいすっきりレモネード！'
            },
            prlImg: {
              src: require('@/../static/images/lineup_bg_j_lemonade.jpg')
            }
          }
        }
      }, {
        // ワイルドベリー
        key: 'j_wildberry',
        prefixTitle: 'ジューシーズ',
        title: 'ワイルドベリー',
        title2: 'withアップルベース',
        english: 'Wildberry with Apple base',
        energy: 47,
        material: 'カシス、ボイセンベリー',
        materialType: '濃縮還元果汁',
        category: 'juicies',
        display: {
          color: '#d10a74',
          lightColor: '#f5d2de',
          descriptions: [
            'りんごのストレート果汁にボイセンベリー、カシスの還元果汁をミックス。',
            '甘さと酸味がミックスされた爽やかな味わいです。'
          ],
          image: {
            itemImg: {
              src: require('@/../static/images/item-l_j_wildberry.png'),
              alt: 'ワイルドベリー商品画像'
            },
            commentImg: {
              src: require('@/../static/images/lineup_cmt_j_wildberry.svg'),
              alt: '酸味のきいた大人のベリー味!'
            },
            prlImg: {
              src: require('@/../static/images/lineup_bg_j_wildberry.jpg')
            }
          }
        }
      }, {
        // ココナッツストロベリー
        key: 'c_strawberry',
        prefixTitle: 'ココナッツジューシーズ',
        title: 'ストロベリー',
        title2: 'withアップルベース',
        english: 'Strawberry with Apple base',
        energy: 46,
        material: 'ストロベリー',
        materialType: 'ピューレ',
        category: 'coconuts',
        display: {
          color: '#ee7c57',
          lightColor: '#f0bba8',
          descriptions: [
            'りんごのストレート果汁にココナッツクリーム、ストロベリーピューレをミックス。',
            'ストロベリーの甘さと酸味、ココナッツの風味が楽しめます。'
          ],
          image: {
            itemImg: {
              src: require('@/../static/images/item-l_c_strawberry.png'),
              alt: 'ココナッツストロベリー商品画像'
            },
            commentImg: {
              src: require('@/../static/images/lineup_cmt_c_strawberry.svg'),
              alt: 'スキッとストロベリーにココナッツの風味が合う！'
            },
            prlImg: {
              src: require('@/../static/images/lineup_bg_c_strawberry.jpg')
            }
          }
        }
      }, {
        // ココナッツパイン
        key: 'c_pine',
        prefixTitle: 'ココナッツジューシーズ',
        title: 'パインアップル',
        title2: 'withアップルベース',
        english: 'Pineapple with Apple base',
        energy: 46,
        material: 'パインアップル',
        materialType: '濃縮還元果汁',
        category: 'coconuts',
        display: {
          color: '#39b059',
          lightColor: '#bcecc9',
          descriptions: [
            'りんごのストレート果汁にココナッツクリーム、パインアップルの還元果汁をミックス。',
            'パインの爽やかさとココナッツの風味が楽しめます。'
          ],
          image: {
            itemImg: {
              src: require('@/../static/images/item-l_c_pineapple.png'),
              alt: 'ココナッツパイン商品画像'
            },
            commentImg: {
              src: require('@/../static/images/lineup_cmt_c_pineapple.svg'),
              alt: 'さわやかパインにココナッツをミックス！'
            },
            prlImg: {
              src: require('@/../static/images/lineup_bg_c_pineapple.jpg')
            }
          }
        }
      }, {
        // ココナッツマンゴー
        key: 'c_mango',
        prefixTitle: 'ココナッツジューシーズ',
        title: 'マンゴー',
        title2: 'withアップルベース',
        english: 'Mango with Apple base',
        energy: 46,
        material: 'マンゴー',
        materialType: 'ピューレ',
        category: 'coconuts',
        display: {
          color: '#f08a53',
          lightColor: '#f2c7ad',
          descriptions: [
            'りんごのストレート果汁にココナッツクリーム、マンゴーピューレをミックス。',
            'マンゴーの甘さとほのかに香るココナッツの風味を楽しめます。'
          ],
          image: {
            itemImg: {
              src: require('@/../static/images/item-l_c_mango.png'),
              alt: 'ココナッツマンゴー商品画像'
            },
            commentImg: {
              src: require('@/../static/images/lineup_cmt_c_mango.svg'),
              alt: 'マンゴーとココナッツのまろやかテイスト！'
            },
            prlImg: {
              src: require('@/../static/images/lineup_bg_c_mango.jpg')
            }
          }
        }
      }]
    }
  },
  computed: {
    categoryJuicies () {
      return _.filter(this.items, function (item) {
        return item.category === 'juicies'
      })
    },
    categoryCoconuts () {
      return _.filter(this.items, function (item) {
        return item.category === 'coconuts'
      })
    }
  },
  created: function () {
    // Window Height
    window.addEventListener('resize', this.setWindowWidth, false)
    window.addEventListener('resize', this.setWindowHeight, false)
    // Video
    setTimeout(() => {
      this.video = false
    }, 4500)
  },
  beforeDestroy: function () {
    window.removeEventListener('resize', this.setWindowWidth, false)
    window.removeEventListener('resize', this.setWindowHeight, false)
  }
}
</script>

<style scoped lang="stylus">
@import url('https://fonts.googleapis.com/css?family=Dokdo')
@import url('https://fonts.googleapis.com/css?family=Kosugi+Maru');

// breakpoint
screen-xxs = 500px
screen-xs = 600px
screen-sm = 960px
screen-md = 1264px
screen-lg = 1904px
breakpoint(bpName)
    for name in bpName
        if name == 'xl-up'
            @media only screen and (min-width: screen-lg + 1)
                {block}
        if name == 'lg-up'
            @media only screen and (min-width: screen-md + 1)
                {block}
        if name == 'md-up'
            @media only screen and (min-width: screen-sm + 1)
                {block}
        if name == 'sm-up'
            @media only screen and (min-width: screen-xs + 1)
                {block}
        if name == 'md'
            @media only screen and (max-width: screen-md)
                {block}
        if name == 'sm'
            @media only screen and (max-width: screen-sm)
                {block}
        if name == 'xs'
            @media only screen and (max-width: screen-xs)
                {block}
        if name == 'xxs'
            @media only screen and (max-width: screen-xxs)
                {block}
//br
br.xs
  +breakpoint(sm-up)
    display none
br.sm-up
  +breakpoint(xs)
    display none

$dropshadow
  filter drop-shadow(0px 0px 5px rgba(0,0,0,.3))

.border_branch
  position absolute
  width 100%
  height 90px
  background url(../../../../../static/images/border_branch.png) repeat-x
  background-size contain
  z-index 1
  margin -20px 0
.border_branch_t
  height 50px
  @extend .border_branch

.bg_lawn
  background: url(../../../../../static/images/bg_lawn.png) repeat
  width 100%
  h1,h2,p,span
    color #fff

/*-------------------------------------------------------------------------*/
main
  overflow hidden
  +breakpoint(sm)
    margin-top -2px
  font-family: 'Kosugi Maru', sans-serif;

$topMaxWidth = 2000px
$topHeight = 870px

#top
  margin 0 auto
  padding-top 0
  max-width $topMaxWidth
  +breakpoint(sm)
    margin-top 50px
  .contents_wrap,.top_mask
    height $topHeight
    +breakpoint(xl-up)
      height $topHeight * 1.2
    +breakpoint(sm)
      height $topHeight * .8
    +breakpoint(xs)
      height $topHeight * .52
  .contents_wrap
    background-image url(../../../../../static/images/top.jpg)
    background-position center center
    position relative
    overflow hidden
    background-size cover
  video
    position absolute
    top 0
    right 0
    min-width 100%
    min-height 100%
    width auto
    height auto
    z-index 0
    +breakpoint(xs)
      background none
  .contents
    display flex
    align-items flex-end
    justify-content center
    margin-bottom 0
    +breakpoint(sm)
      margin-top 40%
  .top_mask
    overflow hidden
    position absolute
    z-index 1
    width 100%
    max-width $topMaxWidth
    .mask
      @extend .bg_lawn
      position absolute
      width 100%
      height 100%
      mask-image url(../../../../../static/images/mask_top.svg)
      mask-mode alpha
      mask-repeat no-repeat
      mask-size 100%
      mask-position bottom center
    .scroll
      position absolute
      left 50%
      bottom 0
      a
        padding-top 80px
        position absolute
        bottom 0
        i
          position absolute
          top 0
          width 30px
          height 50px
          margin-left -15px
          box-sizing border-box
          +breakpoint(sm-up)
            border 2px solid #fff
            border-radius 50px
          &::before
            position absolute
            top 10px
            +breakpoint(sm-up)
              content ''
              width 6px
              height 6px
              margin-left -3px
              background-color #fff
              border-radius 100%
              box-sizing border-box
          &::after
            position absolute
            bottom -18px
            width 18px
            height 18px
            content ''
            margin-left -9px
            border-left 2px solid #fff
            border-bottom 2px solid #fff
            transform rotate(-45deg)
            box-sizing border-box

.bounce
  animation animation 1000ms linear both
@keyframes animation {
  0% { transform: matrix3d(0.9, 0, 0, 0, 0, 0.9, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); }
  10% { transform: matrix3d(0.988, 0, 0, 0, 0, 1.185, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); }
  20% { transform: matrix3d(1.021, 0, 0, 0, 0, 0.934, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); }
  30% { transform: matrix3d(1.013, 0, 0, 0, 0, 0.865, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); }
  40% { transform: matrix3d(0.997, 0, 0, 0, 0, 1.044, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); }
  60% { transform: matrix3d(1, 0, 0, 0, 0, 1.001, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); }
  80% { transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); }
  100% { transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); }
}
#about
  margin-top -200px
  padding-top 200px
  .side_item
    position relative
    z-index 1
    width 100%
    .side_r
      right 0
    img
      position absolute
      z-index 2
      width 25%
      top -100px
      +breakpoint(xs)
        width 30%
        top -60px
  .buttons
    .flex
      height 200px
      cursor pointer
      background-image url(../../../../../static/images/wood_btn.png)
      background-size contain
      background-position center
      @extend $dropshadow
      +breakpoint(md-up)
        &:hover
          @extend .bounce
      +breakpoint(xs)
        height 180px
    a
      padding-top 70px
      font-size 1.2rem
      text-align center
      display block
      +breakpoint(xs)
        font-size 1.1rem
    img
      margin 20px auto
      +breakpoint(xs)
        margin 0 auto
  h1
    font-size 1.4rem
    line-height 2.2rem
    text-align center
    font-weight normal
    padding 30px 0
    background url(../../../../../static/images/bg_h1.png)
    height 160px
    +breakpoint(xs)
      padding 40px 0
  p
    font-size 1.4rem
    +breakpoint(xs)
      font-size 1.2rem

#point.container
    max-width 1000px
  #point
    +breakpoint(xs)
      margin-top -40px
    .point_wrap
      margin-bottom 50px
    .point_wrap:nth-child(odd)
      .heading_wrap
        flex-flow row-reverse
        .arrow
          transform rotate(180deg)
      +breakpoint(sm-up)
        flex-flow row-reverse
    h3,p
      font-size 1.4rem
      color #fff7d3
      text-aline left
      +breakpoint(sm)
        font-size 1.1rem
        line-height 1.3rem
    .heading
      width 100%
      @extend $dropshadow
    .side
      overflow hidden
      margin-top 100px
      img
        display inline-block
        margin-bottom 60%
    .side_l
      img
        float right
#scene
  padding-bottom 100px
  h3
    font-size 1.5rem
  p
    @extend #point p
  span
    font-family: 'Dokdo', cursive;
    font-size 7rem
    line-height 5rem
    display block
    +breakpoint(sm)
      font-size 5rem
      line-height 3rem
  .layout:nth-child(odd)
    +breakpoint(sm-up)
      flex-flow row-reverse
    .photo,h3,p,span
      text-align right
      transform rotate(2deg)
      +breakpoint(sm-up)
        padding-right 30px
  .layout:nth-child(even)
    .photo,h3,p,span
      transform rotate(-2deg)
      +breakpoint(sm-up)
        padding-left 30px
  .images
    position relative
    .photo
      border 10px solid #fff
      border-bottom 50px solid #fff
      @extend $dropshadow
      +breakpoint(sm)
        height 280px
    .pic
      width 200px
      position absolute
      bottom -50px
      +breakpoint(sm)
        width 150px
  .item
    height 180px
    +breakpoint(sm)
      height 120px
  .i0
    transform rotate(20deg)
    margin -10px 0 0 80%
  .i1
    transform rotate(-20deg)
    margin -20px 0 0 10%
  .i2
    transform rotate(10deg)
    margin -10px 0 0 90%
  .i3
    transform rotate(-25deg)
    margin -20px 0 0 10%

main
  #lineup
    .v-parallax
      height clamp(400px,50vw,700px)
#lineup
  .lu_head
    padding-top 70px
    +breakpoint(xs)
      padding-top 30px
  .item_text
    display block
    text-shadow #fff 1px 1px 2px, #fff -1px 1px 2px,#fff 1px -1px 2px, #fff -1px -1px 2px
    +breakpoint(xs)
      margin-top 0
  .new
    position absolute
    z-index 1
    width 100px
    right 20px
    top 0
    +breakpoint(xs)
      width 70px
      top auto
      bottom 50px
      left 80px
      right auto
  .board
    background url(../../../../../static/images/lineup_board.png) no-repeat
    background-size contain
    width 170px
    height 170px
    padding 45px 15px
    font-size 0.7rem
    margin 0 auto
    font-weight bold
    text-shadow none
    +breakpoint(xs)
      width 155px
      height 155px
  .v-parallax
    +breakpoint(xs)
      height 350px !important
  .item_title
    display inline-block
    font-size 2rem
    line-height 1.7rem
    +breakpoint(xs)
      font-size 1.5rem
      line-height 1.5rem
  .item_img
    margin-top 30px
  .item_comment
    width 300px
    margin 0 auto
  h2
    font-size 1.3rem
    margin-top 10px
  .item_wrap
    .lu_head,.lu_head_mask
      background url(../../../../../static/images/bg_wood.png) repeat-x
      /* Background pattern from Toptal Subtle Patterns */
    .lu_head
      img
        +breakpoint(md-up)
          padding-top 50px
    &:nth-of-type(n)
      .item_img
        transform rotate(-10deg)
    &:nth-of-type(2n)
      .item_img
        transform rotate(-10deg)
    &:nth-of-type(3n)
      .item_img
        transform rotate(5deg)
  +breakpoint(md-up)
    .item_wrap
      &:nth-of-type(n)
        .item_contents
          margin 0 0 0 30%
      &:nth-of-type(2n)
        .item_contents
          margin 0 0 0 20%
      &:nth-of-type(3n)
        .item_contents
          margin 0 0 0 30%
   .series_c
     .lu_head,.lu_head_mask
       background url(../../../../../static/images/bg_paper.png) repeat
  .lu_head_mask
    mask-image url(../../../../../static/images/mask_sub.svg)
    mask-mode alpha
    mask-repeat repeat-x
    mask-position bottom
    mask-size 60%
    height 30px
#nz
  position relative
  background url(../../../../../static/images/nz_image.jpg) no-repeat
  background-size cover
  background-position left top
  +breakpoint(xs)
    height 500px
  .flag
    max-width 250px
    transform: rotate( -20deg )
  .apple
    position relative
    margin: 0 auto 60px
    max-width 400px
    padding-bottom 500px
    .v_image,.v-responsive
      position absolute
      width 100%
    +breakpoint(xs)
       padding-bottom 350px
       max-width 250px
  h2
    font-size 1.6rem
    padding-top 100px
    +breakpoint(xs)
      padding-top 30px
  h2,p
    text-shadow #5bb4ec 1px 1px 5px,
                #5bb4ec -1px 1px 5px,
                #5bb4ec 1px -1px 5px,
                #5bb4ec -1px -1px 5px

#freezer
  padding-top 250px
  +breakpoint(xs)
    padding-top 100px
  span
    font-size 1.5rem
  h2
    font-size 2.2rem
  a
    text-decoration none
  .v-btn
    padding 0 30px
    border-radius 50px
    height 100px
    p
      font-size 1.3rem
      font-weight bold
    span
      font-size 1rem
      line-height 1.2rem
      display inline-block
      font-weight:normal

#awords
  img
    margin 0 auto
    display inline-block
    +breakpoint(xs)
      max-width 140px
  p
    line-height 1.2rem

#character
  padding-bottom 150px
  p
    font-size 1.9rem
  img
    margin 0 auto
  span
    font-size 0.9rem
.border_flag
  display block
  background url(../../../../../static/images/border_flag.png) repeat-x
  background-size contain
  background-position center
  height 180px
  +breakpoint(xs)
    background-size 200%
.border_leaf
  display block
  background url(../../../../../static/images/border_leaf.png) repeat-x
  width 100%
  height 180px
  margin-top -100px

#company
  h2
    font-size 1.3rem
  p,address,.mail
    font-size 0.9rem
    line-height 1.1rem
    font-weight normal
    font-style normal
  a
    font-size 0.9rem
    text-decoration none
  img
    width 200px
    margin 0 auto

.v-leave-active
  transition opacity 1s
.v-leave-to
  opacity 0

//Footer
.footer_pic
  background url(../../../../../static/images/footer_pic_apple.png) no-repeat
  background-position bottom 0 right -15px

//IE
@media all and (-ms-high-contrast: none)
  .mask
    display none
  #about
    .logo
      padding-top 80px
  .buttons
    flex-basis 25%
  #point
    .svg
      width 350px
      height 300px
  #top
    .top_upper
      .scroll
        a
          i
            border none
            &::before
              display none
            &::after
              margin-left 0

//Edge
@supports (-ms-ime-align: auto)
  .mask
   display none
  .v-image
    min-height 100%
  #about
    .logo
      min-height 200px
  #point
    .heading.v-image
      min-height 150px
  #scene
    .pic
      min-height 200px
      height 200px
    .photo
      min-height 380px
  #point,#scene
    h2
      .v-image
        min-height 150px
  #lineup
    .item_img.v-image
      min-height 405px
</style>



// WEBPACK FOOTER //
// src/app/pages/Landing/Top/index.vue